// import { mapState } from 'vuex'
// import theme from '@/component/js/theme'

import ImageTab from '@/component/ui2/imageTab/ImageTab'
import ImageTab2 from '@/component/ui2/imageTab/ImageTab2'
import QuickBoard from '@/app/board/QuickBoardList'
import UserBanner from '@/component/layout/UserBanner'
import ComponentsRenderer from '@/component/common/components-renderer.js'

export default {
  name: 'components-renderer',
  functional: true,
  // mixins: [theme],
  props: {
    components: { type: Array, required: true }
  },
  render (createElement, context) {
    const extraClass = attrs => {
      if (!attrs || !attrs.hasOwnProperty('extraClass')) return ''
      return attrs.extraClass
    }
    const style = attrs => {
      if (!attrs) return ''

      const { style = '', to = '', menuName = '' } = attrs
      return `${style} ${to || menuName ? 'cursor: pointer' : ''}`
    }
    const chunks = (chunk, arr) => {
      let i = 0
      let j = arr.length || 0
      let ret = []
      while (i < j) {
        ret.push(arr.slice(i, i + chunk))
        i += chunk
      }
      // console.log('ret---', ret)
      return ret
    }
    function go ({ to = '', menuName = '' }, { $router, $store }) {
      return function (event) {
        event.stopPropagation()
        event.preventDefault()

        if (!to && !menuName) {
          return
        }
        if (menuName) {
          const matched = $store.state.menus.all.filter(menu => menu.menuName === menuName)
          if (!matched.length) {
            return
          }
          $router.push(matched[0].route)
        }
        if (to) {
          $router.push(to)
        }
        // console.log('name', name, params)
      }
    }
    return context.props.components.map(component => {
      const { type } = component
      if (component.hasOwnProperty('attrs') && component.attrs.hasOwnProperty('mq')) {
        const { mq } = component.attrs
        const { $mq } = context.parent

        if (mq === 'mobile' && $mq !== 'mobile') {
          return null
        }
        if (mq !== 'mobile' && $mq === 'mobile') {
          return null
        }
      }

      let on = null
      if (
        component.hasOwnProperty('attrs') &&
        (component.attrs.hasOwnProperty('to') || component.attrs.hasOwnProperty('menuName'))
      ) {
        on = { click: go(component.attrs, context.parent) }
      }

      if (type === 'v-html') {
        return createElement('div', {
          domProps: {
            innerHTML: component.attrs['v-html']
          }
        })
        // } else if (type === 'a') {
        //   let children = null
        //   if (component.hasOwnProperty('components')) {
        //     children = createElement(ComponentsRenderer, { props: { components: component.components } })
        //   }
        //   const a = createElement(
        //     'a',
        //     {
        //       class: extraClass(component.attrs),
        //       style: style(component.attrs),
        //       on
        //     },
        //     children
        //     // component.attrs.text
        //   )
        //   return a
      } else if (type === 'text') {
        return context._v(component.attrs.text)
      } else if (type === 'img') {
        return createElement('img', {
          class: extraClass(component.attrs),
          style: style(component.attrs),
          on,
          attrs: {
            src: `/api/resources/files/${component.attrs.src}`
          }
        })
      } else if (type === 'imageTab') {
        return createElement(ImageTab, {
          props: {
            images: component.attrs.images,
            extraClass: extraClass(component.attrs),
            style: style(component.attrs)
          }
        })
      } else if (type === 'imageTab2') {
        return createElement(ImageTab2, {
          props: {
            tabs: component.attrs.tabs,
            images: component.attrs.images,
            extraClass: extraClass(component.attrs),
            style: style(component.attrs)
          }
        })
      } else if (type === 'banner') {
        return createElement(UserBanner, {
          props: {
            extraClass: extraClass(component.attrs),
            style: style(component.attrs)
          }
        })
      } else if (type === 'quickBoard') {
        // console.log('quickBoard', component)
        const ret = createElement(QuickBoard, {
          props: {
            boardId: component.attrs.boardId,
            type: component.attrs.type,
            extraClass: extraClass(component.attrs),
            style: style(component.attrs)
          }
        })
        return ret
      } else if (type === 'container') {
        const children1 = chunks(component.attrs.columns.desktop, component.components).map(chunkArr => {
          const children2 = chunkArr.map(chunk => {
            const children3 = createElement(ComponentsRenderer, { props: { components: [chunk] } })
            return createElement(
              'div',
              {
                class: `col-d-${12 / component.attrs.columns.desktop} col-m-${12 /
                  component.attrs.columns.mobile} ${extraClass(component.attrs.columns)}`,
                style: `${style(component.attrs.columns)}`
              },
              children3
            )
          })
          return createElement(
            'div',
            {
              class: 'clearfix'
            },
            children2
          )
        })

        return createElement(
          'div',
          {
            class: extraClass(component.attrs),
            style: style(component.attrs)
          },
          children1
        )
      } else if (type === 'link') {
        if (component.attrs && component.attrs.hasOwnProperty('seq')) {
          const { seq } = component.attrs
          if (context.parent.$store.state.designPost.seq.hasOwnProperty(seq)) {
            const post = context.parent.$store.state.designPost.seq[seq]
            const children = createElement(ComponentsRenderer, { props: { components: post.components || [] } })
            return createElement(
              'div',
              {
                class: extraClass(component.attrs),
                style: style(component.attrs)
              },
              children
            )
          }
        } else if (component.attrs && component.attrs.hasOwnProperty('key')) {
          const { key } = component.attrs
          if (context.parent.$store.state.designPost.key.hasOwnProperty(key)) {
            const post = context.parent.$store.state.designPost.key[key]
            const children = createElement(ComponentsRenderer, { props: { components: post.components || [] } })
            return createElement(
              'div',
              {
                class: extraClass(component.attrs),
                style: style(component.attrs)
              },
              children
            )
          }
        }
      } else if (
        type === 'a' ||
        // type === 'i' ||
        type === 'span' ||
        type === 'strong' ||
        type === 'p' ||
        type === 'div' ||
        type === 'h1' ||
        type === 'h2' ||
        type === 'h3' ||
        type === 'h4' ||
        type === 'h5' ||
        type === 'h6'
      ) {
        let children = null
        if (component.hasOwnProperty('components')) {
          children = createElement(ComponentsRenderer, { props: { components: component.components } })
        }
        // let on = null
        // if (type === 'a' || component.attrs.hasOwnProperty('menuName')) {
        //   console.log('component.attrs.menuName', component.attrs.menuName)
        //   on = {
        //     click: go(component.attrs, context.parent)
        //     // click: event => {
        //     //   const { to = '', menuName = '' } = component.attrs
        //     //   console.log('go-----------', to, menuName, event, component.attrs)
        //     //   if (!to && !menuName) {
        //     //   }
        //     //   // go(component.attrs, context.parent)
        //     // }
        //   }
        // }
        return createElement(
          type,
          {
            class: extraClass(component.attrs),
            style: style(component.attrs),
            on
          },
          children
        )
      }
    })
  },
  components: {
    ComponentsRenderer
  }
}
